import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useGetSettingFinancialStatement from '../../../../companyAnalysis/financial/common/useGetSettingFinancialStatement'
import {
  getDefaultDynamicReport,
  handleAfterGetDefaultCompanyAnalysis,
  handleBeforeGetDefaultCompanyAnalysis,
} from '../../helper'
import {
  addDataKeepSetting,
  changeCompanyType,
  changeDataKeepSetting,
  changeIsKeepingSetting,
  changeMainScreen,
  changeSettingFs,
  selectDataKeepSetting,
} from './store/slice'

const HandleKeepSetting = () => {
  const dispatch = useDispatch()

  const settingFsCompanyAnalysis = useGetSettingFinancialStatement()

  const data = useSelector(selectDataKeepSetting)

  useEffect(() => {
    handleKeepData()
  }, [])

  const handleClose = () => {
    dispatch(changeDataKeepSetting(null))
  }

  const handleKeepData = async () => {
    if (data) {
      dispatch(changeMainScreen(data.mainScreen))
      if (data.organizationId) {
        dispatch(changeIsKeepingSetting(true))
        dispatch(changeSettingFs(settingFsCompanyAnalysis))
        dispatch(changeCompanyType(data.companyType))
        await handleBeforeGetDefaultCompanyAnalysis({
          dispatch,
          companyType: data.companyType,
        })
      }
      dispatch(
        addDataKeepSetting(
          getDefaultDynamicReport(data.mainScreen, {
            companyType: data.companyType,
          }).map((items) => ({
            ...items,
            mainScreen: data.mainScreen,
          })),
        ),
      )

      handleAfterGetDefaultCompanyAnalysis({ dispatch })
      handleClose()
    }
  }

  return <></>
}

export default HandleKeepSetting
